import { css } from '@emotion/css';
import { Theme } from 'src/lib/theme/types';

export const main = (_: Theme) => css`
  border: none;
`;
